import { render } from "./LabelLocationMap.vue?vue&type=template&id=0b415ffe&scoped=true"
import script from "./LabelLocationMap.vue?vue&type=script&lang=js"
export * from "./LabelLocationMap.vue?vue&type=script&lang=js"

import "./LabelLocationMap.vue?vue&type=style&index=0&id=0b415ffe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b415ffe"]])

export default __exports__